import Default from '@pages/profile'

export default {
  path: 'profile/:id?',
  name: 'profile',
  components: {
    default: Default,
  },
}